import React from 'react'
import styles from './TitleAndDesc.module.css'

const TitleAndDesc = ( {title, desc, style} ) => {
  return (
    <div className={styles.wrapper} style={style}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{desc}</p>
    </div>
  )
}

export default TitleAndDesc